import React, { Fragment } from 'react';
import { HomeView } from './HomeView';
import { MapView } from './MapView';
import { OutageView } from './OutageView';
import {
  ResponsivePageView,
  useOutageResponsivePageTracker,
} from '../../providers/OutageResponsivePageTracker';

function MobileSubHeader() {
  const { page } = useOutageResponsivePageTracker();

  return (
    <Fragment>
      {page === ResponsivePageView.Map && <MapView />}
      {page === ResponsivePageView.Home && <HomeView />}
      {page === ResponsivePageView.Details && <OutageView />}
    </Fragment>
  );
}

export default MobileSubHeader;
